<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="container">
    <h2>{{ $t("auth.idpError.signInBlocked") }}</h2>
    <p>{{ $t("auth.idpError.alreadySignedIn") }}</p>
    <p>{{ $t("auth.idpError.nextSteps") }}</p>
    <ul>
      <li>{{ $t("auth.idpError.signOut") }}</li>
      <li>{{ $t("auth.idpError.useIncagnito") }}</li>
      <li>{{ $t("auth.idpError.clearCookies") }}</li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'idp-error',
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 20px;
}
</style>
